import { render } from "./simpeg-pegawai-gaji-import.vue?vue&type=template&id=6a08d53a"
import script from "./simpeg-pegawai-gaji-import.vue?vue&type=script&lang=js"
export * from "./simpeg-pegawai-gaji-import.vue?vue&type=script&lang=js"

import "./simpeg-pegawai-gaji-import.vue?vue&type=style&index=0&id=6a08d53a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__